export class Aforo {
  id!: number;
  numberPeople!: number;
  percentageCapacity!: number;
  peopleCapacity!: number;
}
